/**
 * Data layer for the COMPANY panel's Habit Tracker section.
 * Same page-facing shapes as container/HabitsHub/habitsHubApi.js, but backed
 * by the company/v1 habits-hub endpoints (token-scoped to the company; the
 * B2B/Members toggle is appended by api/companyApi.js on every call).
 */

import {
  getCompanyHabitsDashboard,
  getCompanyHabitsUsers,
  getCompanyHabitsUserDetail
} from '../../../../api/companyApi';
import { unwrap } from '../../../SleepHub/sleepHubApi';
import { adaptDashboard, adaptUserDetail } from '../../../HabitsHub/habitsHubApi';

export const fetchCompanyHabitsDashboard = async () => {
  try {
    const data = unwrap(await getCompanyHabitsDashboard());
    return {
      ...adaptDashboard(data),
      // Company-only: the size of the population, so the page can say
      // "32 of 240 employees track a habit".
      totalUsers: data.totalUsers
    };
  } catch (error) {
    console.error('fetchCompanyHabitsDashboard error:', error);
    return null;
  }
};

// Matches the HabitUsersTable fetcher contract ({page, perPage, search}).
export const fetchCompanyHabitsUsers = async ({ page = 1, perPage = 10, search = '' } = {}) => {
  try {
    const data = unwrap(await getCompanyHabitsUsers(page, perPage, search));
    return { data: data.data || [], totalCount: data.totalCount || 0 };
  } catch (error) {
    console.error('fetchCompanyHabitsUsers error:', error);
    return { data: [], totalCount: 0 };
  }
};

export const fetchCompanyHabitsUserDetail = async (userId) => {
  try {
    // Adapted through the shared shaper, not returned raw — the trend series
    // has to arrive at the chart as numbers, not { date, completions } rows.
    return adaptUserDetail(unwrap(await getCompanyHabitsUserDetail(userId)));
  } catch (error) {
    console.error('fetchCompanyHabitsUserDetail error:', error);
    return null;
  }
};
